/**
 * 直销订单状态
 * PRE_CREATE("PRE_CREATE", "预创建"),
 *     WAIT_PAY("WAIT_PAY", "待支付"),
 *     FINISH("FINISH", "订单完成"),
 *     CANCEL("CANCEL", "订单取消"),
 *     WAIT_DELIVERY("WAIT_DELIVERY", "待发货"),
 *     WAIT_RECEIVE("WAIT_RECEIVE", "待收货"),
 *     PART_RECEIVE("PART_RECEIVE", "部分收货"),
 *     WAIT_TAKE("WAIT_TAKE", "带自提");
 *     退款中 TKZ
 *     退款成功 TKCG
 *     退款失败  JJ
 */
export enum ZdsOrderStatus {
  PRE_CREATE = 'PRE_CREATE',
  WAIT_PAY = 'WAIT_PAY',
  WAIT_DELIVERY = 'WAIT_DELIVERY',
  WAIT_RECEIVE = 'WAIT_RECEIVE',
  PART_RECEIVE = 'PART_RECEIVE', // 部分收货
  WAIT_TAKE = 'WAIT_TAKE',
  FINISH = 'FINISH',
  CANCEL = 'CANCEL',
  TKZ = 'TKZ',
  TKCG = 'TKCG',
  JJ = 'JJ'
}

export const ZdsOrderStatusMap = {
  // [ZdsOrderStatus.PRE_CREATE]: '预创建',
  [ZdsOrderStatus.WAIT_PAY]: '待支付',
  [ZdsOrderStatus.WAIT_DELIVERY]: '待发货',
  [ZdsOrderStatus.WAIT_RECEIVE]: '待收货',
  [ZdsOrderStatus.PART_RECEIVE]: '部分收货',
  [ZdsOrderStatus.WAIT_TAKE]: '待自提',
  [ZdsOrderStatus.FINISH]: '已完成',
  [ZdsOrderStatus.CANCEL]: '已取消',
  [ZdsOrderStatus.TKZ]: '退款中',
  [ZdsOrderStatus.TKCG]: '退款成功',
  [ZdsOrderStatus.JJ]: '退款失败',
}

export const ZdsOrderStatusOptions = Object.entries(ZdsOrderStatusMap).map(([key, value]) => ({ label: value, value: key }))

/**
 * 是否邮递
 *     TAKE("TAKE", "自取"),
 *     DROP_SHIPPING("DROP_SHIPPING", "一件代发");
 */
export enum ZdsOrderDeliveryType {
  TAKE = 'TAKE',
  DROP_SHIPPING = 'DROP_SHIPPING',
}

export const ZdsOrderDeliveryTypeMap = {
  [ZdsOrderDeliveryType.DROP_SHIPPING]: '是',
  [ZdsOrderDeliveryType.TAKE]: '否',
}

export const ZdsOrderDeliveryTypeOptions = Object.entries(ZdsOrderDeliveryTypeMap).map(([key, value]) => ({ label: value, value: key }))

/**
 * 支付方式
 * ALIPAY("ALIPAY", "支付宝"),
 *     WECHAT("WECHAT", "微信"),
 *     MEAL_CARD("MEAL_CARD","饭卡"),
 */
export enum ZdsOrderPayMode {
  WECHAT = 'WECHAT',
  ALIPAY = 'ALIPAY',
  MEAL_CARD = 'MEAL_CARD'
}

export const ZdsOrderPayModeMap = {
  [ZdsOrderPayMode.WECHAT] : '微信支付',
  [ZdsOrderPayMode.MEAL_CARD] : '中通卡支付',
  [ZdsOrderPayMode.ALIPAY] : '支付宝支付'
}
export const ZdsOrderPayModeOptions = Object.entries(ZdsOrderPayModeMap).map(([key, value]) => ({ label: value, value: key }))

/**
 * REFUNDING("REFUNDING", "退款中"),
 * REFUND_SUCCESS("REFUND_SUCCESS", "退款成功"),
 * REFUND_FAIL("REFUND_FAIL", "退款失败");
 */
export enum ZdsOrderRefundStatus {
  REFUNDING = 'REFUNDING',
  REFUND_SUCCESS = 'REFUND_SUCCESS',
  REFUND_FAIL = 'REFUND_FAIL',
}
export const ZdsOrderRefundStatusMap = {
  [ZdsOrderRefundStatus.REFUNDING] : '退款中',
  [ZdsOrderRefundStatus.REFUND_SUCCESS] : '退款成功',
  [ZdsOrderRefundStatus.REFUND_FAIL] : '退款失败',
}
